module.exports = __webpack_public_path__ + "static/media/1.1b2b8b84.jpg";